import { render, staticRenderFns } from "./data_trend.vue?vue&type=template&id=36ae09a7&scoped=true"
import script from "./data_trend.vue?vue&type=script&lang=js"
export * from "./data_trend.vue?vue&type=script&lang=js"
import style0 from "./data_trend.vue?vue&type=style&index=0&id=36ae09a7&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ae09a7",
  null
  
)

export default component.exports